
import crtBg from '@/assets/images/organ_cert_bg.png'
export default class Pxzmcertificatejg {
  // name, curriculum, time, companyName, times_study, index
  constructor(params, callback) {
    // console.log('dataarguments',arguments)
    // this.name = params.name
    this.params = params
    // this.curriculum = curriculum.substring(0, 14)
    // const currentDate = new Date()
    // this.time = `${currentDate.getFullYear()}年${currentDate.getMonth() + 1}月${currentDate.getDate()}日`
    // this.times_study = times_study || 0
    // this.year = time
    // this.companyName = companyName
    this.callback = callback
    this.imgWidth = 492
    this.imgHeight = 739
    this.initMethod()
  }

  initMethod() {
    const img = new Image()
    const that = this
    img.src = crtBg
    img.onload = function() {
      that.createCanvas(img)
    }
  }

  loadNetWorkIMage() {
    //创建img标签
    var img = new Image();
    img.src = this.params.sfzheader;
    if (window.location.host == '127.0.0.1:8080') {
      img.src = './static/images/sfzfmkong.png'
    }
    //跨域选项
    img.setAttribute("crossOrigin", 'Anonymous');
    return new Promise((resolve, reject) => {
        //文件加载完毕
        img.onload = function () {
          resolve(img);
        };
    });
  }

  loadQrcodeIMage() {
    //创建img标签
    var img = new Image();
    img.src = './static/images/qrcode_xcx.jpeg'
    //跨域选项
    img.setAttribute("crossOrigin", 'Anonymous');
    return new Promise((resolve, reject) => {
        //文件加载完毕
        img.onload = function () {
          resolve(img);
        };
    });
  }

  async createCanvas(imageItem) {
    var canvas = document.createElement('canvas') // 创建canvas元素
    canvas.width = this.imgWidth // canvas宽度
    canvas.height = this.imgHeight // canvas的高度
    var context = canvas.getContext('2d') // 创建渲染
    context.fillStyle = '#fff'
    context.fillRect(0, 0, this.imgWidth, this.imgHeight)
    context.drawImage(imageItem, 0, 0, this.imgWidth, this.imgHeight)

    // 开始绘制文本
    // 姓名
    this.setText(170, 193, this.params.uname || '', context)
    // 身份证号
    this.setText(170, 223, this.params.IdNum || '', context)

    // 资格类型
    this.setText(170, 253, this.params.odtypename || '', context)

    // 作业类别
    this.setText(170, 283, this.params.type_zuoyetext || '', context)
    // 操作项目
    this.setText(170, 310, this.params.type_zhuncaotext || '', context)
    // 培训类别
    this.setText(170, 340, this.params.type_pxtext || '', context)
    // 培训机构
    this.setText(170, 370, this.params.publish_organ || '', context)
    // 培训日期
    this.setText(170, 399, this.params.time_px || '', context)
    // 培训方式
    this.setText(130, 466, this.params.teaching_way || '', context)
    // 培训学时
    this.setText(310, 466, this.params.times_study || '', context)

   
    if (this.params.sfzheader) {
      const image = await this.loadNetWorkIMage()
      context.drawImage(image, 331, 174, 80, 117)
    }

    const image1 = await this.loadQrcodeIMage()
    context.drawImage(image1, 100, 500, 108, 122)
    // 扫码进入小程序
    this.setText(105, 615, '扫码进入小程序', context)

    var fullQuality = canvas.toDataURL('image/jpeg', 1)
    this.callback(fullQuality, this.index)
  }

  setText(x, y, text, cans) {
    cans.font = 'bold 14px arial'
    cans.fillStyle = '#000000'
    cans.fillText(text, x, y)
  }

  // 获取字符串的真实长度（字节长度）
  getTrueLength(str) {
    var len = str.length; var truelen = 0
    for (var x = 0; x < len; x++) {
      if (str.charCodeAt(x) > 128) {
        truelen += 2
      } else {
        truelen += 1
      }
    }
    return truelen
  }
}
